export default __webpack_public_path__ + "static/media/Microsoft2 - Logo.4b31e7e0.png";